import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  Autocomplete,
  TextField,
  Stack,
  InputAdornment,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import { getProject } from "../../services/project.service";
import {
  DatePicker,
  TimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { getTokenbyData, getUser } from "../../services/user.service";
import {
  getProjectBasedUser,
  postTask,
  updateTask,
} from "../../services/taskManagement.service";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { FileUploader } from "react-drag-drop-files";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";

import FileUploadIcon from "../../assets/images/FileUpload_Icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ProjectSide_Icon from "../../assets/images/ProjectSide_Icon.svg";
import Bugs_Icon from "../../assets/images/Bugs_Icon.svg";
import Task_Icon from "../../assets/images/Task_Icon.svg";
import Meeting_Icon from "../../assets/images/Meeting_Icon.svg";
import High_Icon from "../../assets/images/High_Icon.svg";
import Medium_Icon from "../../assets/images/Medium_Icon.svg";
import Low_Icon from "../../assets/images/Low_Icon.svg";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import CommonLoader from "../../common/CommonLoader/CommonLoader";
import { encryptData } from "../../utils/cryptoUtils";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../context/AuthProvider";

const AddTask = (props) => {
  const location = useLocation();

  const selectedRightValue = location.state?.selectedRightValue || null;
  const filteredStatus = location.state?.filteredStatus || null;

  const navigate = useNavigate();
  const { setOpenDrawer, formType, selectedData, GetData } = props;
  const { accessToken } = useAuth();
  const disabled = formType === "view";
  const formRef = useRef(null);
  const [projectData, setProjectData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [adminData, setAdminData] = useState([]);
  const [taskOption, setTaskOption] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [initialValues, setInitialValues] = useState({
    taskType: "",
    title: "",
    description: "",
    project: "",
    assignedBy: "",
    assignedTo: "",
    priority: "",
    deadLineDate: "",
    estimatedTime: "",
    file: [],
  });
  const [meeting, setMeeting] = useState(selectedData?.taskType);
  const [fileName, setFileName] = useState(
    formType === "edit" ? selectedData?.file?.fileName : 0
    // : "Drag & Drop or click to upload videos"
  );

  const fonts = ["Roboto", "Open Sans", "Arial", "Georgia"];

  const validationSchema = Yup.object().shape({
    taskType: Yup.string().required("Issue Type is required"),
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    project: Yup.string().required("Project is required"),
    priority: Yup.string().required("Priority is required"),
    deadLineDate: Yup.string().required("Deadline Date is required"),
    estimatedTime: Yup.string()
      .matches(
        /^(?:(\d+w\s*)?(\d+d\s*)?(\d+h\s*)?(\d+m\s*)?)$/,
        "Use this format: 2w 4d 6h 45m"
      )
      .required("Estimated Time is required"),
  });

  const getUserIdFromToken = () => {
    // const token = localStorage.getItem("token");
    if (!accessToken) return null;

    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };
  const GetProjectData = async () => {
    try {
      const res = await getProject({ isEnabled: true });
      const userId = getUserIdFromToken();

      // Get current user data to check if they are admin
      const userRes = await getTokenbyData();
      const isAdmin = userRes?.data?.isOverAllAdmin || false;

      let filteredProjects = res.data.data;

      // If user is not admin, filter projects where user is a project lead
      if (!isAdmin && userId) {
        filteredProjects = res.data.data.filter((project) => {
          // Check if user is in the projectLead array
          return project.projectLead?.some((lead) => {
            // Handle both object and string ID formats
            const leadId = typeof lead === 'object' ? lead._id : lead;
            return leadId === userId;
          });
        });
      }

      const configData = filteredProjects.map((e) => {
        return {
          ...e,
          label: e.name,
        };
      });
      setProjectData(configData);
    } catch (error) {
      console.log(error);
    }
  };

  const GetProjectBasedUserData = async (selectedProjectId) => {
    try {
      const res = await getProjectBasedUser(selectedProjectId);
      const configData = res?.data?.data?.map((e) => {
        return {
          ...e,
          label: e.fullName,
        };
      });
      setEmployeeData(configData);
    } catch (error) {
      console.log(error);
    }
  };

  // const GetUserData = async () => {
  //   try {
  //     const res = await getUser({ isEnabled: true });
  //     const configData = res?.data?.data?.map((e) => {
  //       return {
  //         ...e,
  //         label: e?.name,
  //       };
  //     });
  //     const adminData = configData.filter((e) => e.isOverAllAdmin === true);
  //     const employeeData = configData.filter((e) => e.isOverAllAdmin === false);

  //     // const unAssignedOption = {
  //     //   _id: "unAssigned",
  //     //   name: "UnAssigned",
  //     //   label: "UnAssigned",
  //     // };
  //     // const employeeDataWithAllOption = [unAssignedOption, ...employeeData]; // Adds "All" at the top of employeeData
  //     // const adminDataWithAllOption = [unAssignedOption, ...adminData]; // Optionally, add to adminData as well if needed

  //     // setAdminData(adminData);
  //     // setEmployeeData(employeeData);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getTokenbyData();
        const usersData = res.data;
        const isClient = usersData?.isClient || false;

        if (isClient) {
          // Fetch client project data if the user is a client
          setTaskOption([
            {
              label: "Task",
              name: "Task",
              icon: (
                <img
                  src={Task_Icon}
                  alt="Task_Icon"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              ),
            },
            {
              label: "Bugs",
              name: "Bugs",
              icon: (
                <img
                  src={Bugs_Icon}
                  alt="Bugs_Icon"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              ),
            },
            // { label: "Feature", name: "Feature" },
          ]);
        } else {
          // Fetch general project data if the user is not a client
          setTaskOption([
            {
              label: "Task",
              name: "Task",
              icon: (
                <img
                  src={Task_Icon}
                  alt="Task_Icon"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              ),
            },
            {
              label: "Bugs",
              name: "Bugs",
              icon: (
                <img
                  src={Bugs_Icon}
                  alt="Bugs_Icon"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              ),
            },
            // {
            //   label: "Feature",
            //   name: "Feature",
            //   icon: (
            //     <img
            //       src={ProjectSide_Icon}
            //       alt="ProjectSide_Icon"
            //       style={{
            //         height: "20px",
            //         width: "20px",
            //       }}
            //     />
            //   ),
            // },
            {
              label: "Meeting",
              name: "Meeting",
              icon: (
                <img
                  src={Meeting_Icon}
                  alt="Meeting_Icon"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              ),
            },
          ]);
        }
        // setOpenLoader(false);
      } catch (error) {
        console.error("Error fetching role data:", error);
      }
    };

    fetchData();
  }, []);

  // const taskOption = [
  //   { label: "Bugs", name: "Bugs" },
  //   { label: "Feature", name: "Feature" },
  //   { label: "Meeting", name: "Meeting" },
  // ];
  const priorityOption = [
    {
      label: "Low",
      name: "Low",
      icon: (
        <img
          src={Low_Icon}
          alt="Low_Icon"
          style={{ height: "20px", width: "20px" }}
        />
      ),
    },
    {
      label: "Medium",
      name: "Medium",
      icon: (
        <img
          src={Medium_Icon}
          alt="Medium_Icon"
          style={{ height: "20px", width: "19px" }}
        />
      ),
    },
    {
      label: "High",
      name: "High",
      icon: (
        <img
          src={High_Icon}
          alt="High_Icon"
          style={{ height: "20px", width: "20px" }}
        />
      ),
    },
  ];

  useEffect(() => {
    GetProjectData();
    GetProjectBasedUserData();
    // GetUserData();
    if (formType === "edit" || formType === "view") {
      const files = selectedData?.file?.map((file) => file?.fileName) || [];
      setInitialValues({
        taskType: selectedData.taskType || "",
        title: selectedData.title || "",
        description: selectedData.description || "",
        project: selectedData.project || "",
        priority: selectedData.priority || "",
        // assignedBy: selectedData.assignedBy || "",
        assignedTo: selectedData?.assignedTo || "",
        deadLineDate: selectedData?.deadLineDate || "",
        estimatedTime: selectedData?.estimatedTime || "",
        // files: selectedData.file || [],
        // files: selectedData.file.map((file) => file.fileName) || [],
      });
      setFileName(files.join(", "));
    }
  }, [formType, selectedData]);

  const handleCancel = () => {
    // navigate(-1);
    navigate("/home/taskManagement", {
      state: {
        selectedRightValue: selectedRightValue,
        filteredStatus: filteredStatus,
      },
    });
  };

  const handleSave = () => {
    navigate(-1);
  };

  const onSubmit = async (values) => {
    try {
      setOpenLoader(true);
      const formData = new FormData();
      const { files, ...bodyData } = values;
      const fieldsToEncrypt = [
        "taskType",
        "title",
        "description",
        "priority",
        "assignedTo",
        "assignedBy",
        "deadLineDate",
        "estimatedTime",
      ];
      const encryptedData = {};
      fieldsToEncrypt.forEach((field) => {
        if (bodyData[field]) {
          encryptedData[field] = encryptData(bodyData[field]);
        }
      });
      // const assignedBy = localStorage.getItem("_id");
      const assignedBy = getUserIdFromToken();
      const filteredBodyData = Object.fromEntries(
        Object.entries({ ...bodyData, ...encryptedData, assignedBy }).filter(
          ([key, value]) => value !== ""
        )
      );
      console.log("Encrypted Data:", encryptedData);
      console.log("Filtered Body Data:", filteredBodyData);
      // if (file) {
      //   formData.append("file", values.file);
      // }
      if (files && files.length) {
        files.forEach((file) => {
          formData.append("files", file);
        });
      }

      formData.append("bodyData", JSON.stringify(filteredBodyData));
      const apiMethod =
        formType === "edit"
          ? updateTask(selectedData._id, formData)
          : postTask(formData);
      const res = await apiMethod;
      console.log("ttp", res);
      ToastSuccess(res.data.message);
      setOpenLoader(false);
      //   GetData();
      // navigate(-1);
      navigate("/home/taskManagement", {
        state: {
          selectedRightValue: selectedRightValue,
          filteredStatus: filteredStatus,
        },
      });
    } catch (error) {
      ToastError(error?.data?.message);
      setOpenLoader(false);
    }
  };

  if (openLoader) {
    // return <CommonLoader />; // Show loading text or spinner
    return (
      <Typography>
        <CommonLoader />
      </Typography>
    );
  }

  return (
    <div className="addRenderingContainer" style={{ background: "white" }}>
      <Box className="addContainerHeader">
        <Typography className="tableTopHead">
          {formType === "edit" ? "Edit" : formType === "view" ? "View" : "Add"}{" "}
          Task
        </Typography>
        {/* <CloseIcon
          sx={{ cursor: "pointer" }}
          onClick={() => setOpenDrawer(false)}
        /> */}
      </Box>
      {/* <Divider sx={{ opacity: 1 }} /> */}
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {({ touched, errors, values, setFieldValue }) => (
          <Form>
            <Box className="addContainerCenter2" mb={1}>
              <Typography className="requiedFields">
                Required fields are marked with an asterisk{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12} sm={6}>
                  <div className="wsh-form-control">
                    <Typography className="inputLabel">
                      Issue Type <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Autocomplete
                      options={taskOption}
                      value={
                        taskOption.find(
                          (option) => option.name === values.taskType
                        ) || null
                      }
                      onChange={(e, v) => {
                        setFieldValue("taskType", v?.name);
                      }}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <span
                            style={{
                              marginRight: "8px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {option.icon}
                          </span>{" "}
                          {/* Adds space between icon and label */}
                          {option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          focused={false}
                          placeholder="Select Task Type"
                          className="AutoComplete_InputBox"
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: values.taskType ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                {/* Render the selected icon */}
                                {
                                  taskOption.find(
                                    (option) => option.name === values.taskType
                                  )?.icon
                                }
                              </div>
                            ) : null,
                          }}
                        />
                      )}
                    />
                    <div className="form-error">
                      {touched.taskType && errors.taskType && errors.taskType}
                    </div>
                  </div>
                </Grid>
                {meeting === "Meeting" ? (
                  <>
                    <Grid item xs={12} sm={6} mt={1}>
                      <div className="wsh-form-control">
                        <Typography className="inputLabel">
                          Project <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <Autocomplete
                          options={projectData}
                          value={
                            projectData.find(
                              (option) => option._id === values.project
                            ) || null
                          }
                          // isOptionEqualToValue={(option, value) =>
                          //   option.id === value.id
                          // }
                          onChange={(e, v) => {
                            setFieldValue("project", v?._id);
                          }}
                          // onChange={(e, v) => setFieldValue("leaveType", v)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              focused={false}
                              placeholder="Select Project"
                              className="AutoComplete_InputBox"
                            />
                          )}
                        />
                        <div className="form-error">
                          {touched.project && errors.project && errors.project}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Title</Typography>
                      <Field
                        name="title"
                        className="InputField"
                        placeholder="Enter Title"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.title && errors.title && errors.title}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Description
                      </Typography>
                      <Field
                        name="description"
                        className="InputField"
                        placeholder="Enter Description"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.description &&
                          errors.description &&
                          errors.description}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Start Time</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          className="datePicker w-100"
                          value={
                            values?.startDate ? dayjs(values?.startDate) : null
                          }
                          onChange={(value) =>
                            setFieldValue("startDate", value)
                          }
                          format="HH:mm"
                        />
                      </LocalizationProvider>
                      <div className="form-error">
                        {touched.startDate &&
                          errors.startDate &&
                          errors.startDate}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">End Time</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          className="datePicker w-100"
                          value={
                            values?.endDate ? dayjs(values?.endDate) : null
                          }
                          onChange={(value) => setFieldValue("endDate", value)}
                          format="HH:mm"
                        />
                      </LocalizationProvider>
                      <div className="form-error">
                        {touched.endDate && errors.endDate && errors.endDate}
                      </div>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12} sm={6}>
                      <div className="wsh-form-control">
                        <Typography className="inputLabel">
                          Project <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <Autocomplete
                          options={projectData}
                          value={
                            projectData.find(
                              (option) => option._id === values.project
                            ) || null
                          }
                          onChange={(e, v) => {
                            setFieldValue("project", v?._id);

                            const selectedId = v?._id || null;
                            GetProjectBasedUserData(selectedId);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              focused={false}
                              placeholder="Select Project"
                              className="AutoComplete_InputBox"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <img
                                      src={ProjectSide_Icon}
                                      alt="Project Icon"
                                      style={{
                                        height: "20px",
                                        width: "20px",
                                        marginRight: "8px", // Adjust the spacing if needed
                                      }}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        />
                        <div className="form-error">
                          {touched.project && errors.project && errors.project}
                        </div>
                      </div>
                    </Grid>

                    {/* <Grid item xs={12} sm={6} mt={1}>
                      <div className="wsh-form-control">
                        <Typography className="inputLabel">
                          Assigned By
                        </Typography>
                        <Autocomplete
                          options={adminData}
                          // value={
                          //   adminData.find(
                          //     (option) => option.name === assignedBy
                          //   ) || null
                          // }
                          value={
                            adminData.find(
                              (option) => option._id === values.assignedBy
                            ) || null
                          }
                          // isOptionEqualToValue={(option, value) =>
                          //   option.id === value.id
                          // }
                          onChange={(e, v) => {
                            setFieldValue("assignedBy", v?._id);
                          }}
                          // onChange={(e, v) => setFieldValue("leaveType", v)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              focused={false}
                              placeholder="Select Assigned By"
                              className="AutoComplete_InputBox"
                            />
                          )}
                        />
                        <div className="form-error">
                          {touched.assignedBy &&
                            errors.assignedBy &&
                            errors.assignedBy}
                        </div>
                      </div>
                    </Grid> */}

                    <Grid item xs={12} sm={6} mt={1}>
                      <div className="wsh-form-control">
                        <Typography className="inputLabel">
                          Priority <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <Autocomplete
                          options={priorityOption}
                          // value={
                          //   adminData.find(
                          //     (option) => option.name === assignedBy
                          //   ) || null
                          // }
                          value={
                            priorityOption.find(
                              (option) => option.name === values.priority
                            ) || null
                          }
                          // isOptionEqualToValue={(option, value) =>
                          //   option.id === value.id
                          // }
                          onChange={(e, v) => {
                            setFieldValue("priority", v?.name);
                          }}
                          renderOption={(props, option) => (
                            <li {...props}>
                              <span
                                style={{
                                  marginRight: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {option.icon}
                              </span>{" "}
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              focused={false}
                              placeholder="Select Priority"
                              className="AutoComplete_InputBox"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: values.priority ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginRight: "8px",
                                    }}
                                  >
                                    {
                                      priorityOption.find(
                                        (option) =>
                                          option.name === values.priority
                                      )?.icon
                                    }
                                  </div>
                                ) : null,
                              }}
                            />
                          )}
                        />
                        <div className="form-error">
                          {touched.priority &&
                            errors.priority &&
                            errors.priority}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} mt={1}>
                      <Typography className="inputLabel">
                        Title <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Field
                        name="title"
                        className="InputField"
                        placeholder="Enter Title"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.title && errors.title && errors.title}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} mt={1}>
                      <Typography className="inputLabel">
                        Description <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Field
                        name="description"
                        render={({ field, form }) => (
                          <ReactQuill
                            value={field.value || ""}
                            onChange={(value) => {
                              form.setFieldValue(field.name, value);
                            }}
                            placeholder="Enter Description"
                            className="EditTextInput"
                            style={{
                              borderRadius: "8px",
                              height: "130px",
                              marginBottom: "40px",
                            }}
                            disabled={disabled}
                            modules={{
                              toolbar: [
                                // [{ font: fonts }],
                                [
                                  { header: "1" },
                                  { header: "2" },
                                  { font: [] },
                                ],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ["bold", "italic", "underline"],
                                [{ align: [] }],
                              ],
                            }}
                          />
                        )}
                      />
                      <div className="form-error">
                        {touched.description &&
                          errors.description &&
                          errors.description}
                      </div>
                    </Grid>
                    {/* <Grid item xs={12} sm={12} mt={1}>
                      <Typography className="inputLabel">
                        Description
                      </Typography>
                      <Field
                        name="description"
                        className="InputField"
                        placeholder="Enter Description"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.description &&
                          errors.description &&
                          errors.description}
                      </div>
                    </Grid> */}
                    <Grid item xs={12} sm={6} mt={1}>
                      <div className="wsh-form-control">
                        <Typography className="inputLabel">
                          Assigned To
                        </Typography>
                        <Autocomplete
                          options={employeeData}
                          value={
                            employeeData.find(
                              (option) => option._id === values.assignedTo
                            ) || null
                          }
                          // isOptionEqualToValue={(option, value) =>
                          //   option.id === value.id
                          // }
                          // value={
                          //   leaveOptions.find(
                          //     (option) => option.name === values.leaveType
                          //   ) || null
                          // }
                          onChange={(e, v) => {
                            setFieldValue("assignedTo", v?._id);
                          }}
                          // onChange={(e, v) => setFieldValue("leaveType", v)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              focused={false}
                              placeholder="Select Assigned To"
                              className="AutoComplete_InputBox"
                            />
                          )}
                        />
                        {/* <div className="form-error">
                          {touched.assignedTo &&
                            errors.assignedTo &&
                            errors.assignedTo}
                        </div> */}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        DeadLine Date <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker", "DatePicker"]}
                        >
                          <DatePicker
                            value={
                              values?.deadLineDate
                                ? dayjs(values?.deadLineDate)
                                : null
                            }
                            onChange={(e) =>
                              setFieldValue("deadLineDate", dayjs(e.$d))
                            }
                            className="datePicker w-100"
                            disabled={disabled}
                            format="DD/MM/YYYY"
                            slots={{
                              openPickerIcon: CalendarTodayRoundedIcon,
                            }}
                            minDate={dayjs()}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div className="form-error">
                        {touched.deadLineDate &&
                          errors.deadLineDate &&
                          errors.deadLineDate}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Estimate Time <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Field
                        name="estimatedTime"
                        className="InputField"
                        placeholder="Enter Estimate Time (e.g : 1w 2d 3h 4m )"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.estimatedTime &&
                          errors.estimatedTime &&
                          errors.estimatedTime}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} mt={1} className="File-Upload">
                      {/* <div className="wsh-form-control"> */}
                      <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography className="inputLabel">
                          Upload Image or Video
                        </Typography>
                        {fileName?.length > 0 && (
                          <HighlightOffIcon
                            onClick={() => {
                              setFileName("");
                              setFieldValue("files", []);
                            }} // Function to remove file
                            style={{
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        )}
                      </Stack>
                      <FileUploader
                        handleChange={(e) => {
                          const files =
                            e instanceof FileList ? Array.from(e) : [e];
                          setFieldValue("files", files);
                          setFileName(
                            files.map((file) => file.name).join(", ")
                          );
                        }}
                        name="files"
                        multiple={true}
                        dropMessageStyle={{
                          color: "green",
                          border: "none",
                          borderRadius: "0px",
                        }}
                      />
                      <Box className="uploadIcon">
                        {/* <CloudUploadOutlinedIcon /> */}
                        <img
                          src={FileUploadIcon}
                          alt="FileUploadIcon"
                          style={{
                            height: "18px",
                            width: "22px",
                          }}
                        />
                        {fileName ? (
                          <span>{fileName}</span>
                        ) : (
                          "Drag & Drop or click to upload files"
                        )}
                      </Box>
                      {/* <div className="form-error">
                        {touched.file && errors.file && errors.file}
                      </div>
                    </div> */}
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>
            <Divider sx={{ opacity: 1 }} />
            <Grid className="addboxFooter">
              <Button
                className="cancelButton"
                // onClick={() => setOpenDrawer(false)}
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="saveButton"
                sx={{ display: disabled ? "none" : "flex" }}
              >
                Save
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddTask;
